import appConfig from '@/config'
import Popup from '@/utils/popup'
import cn from '@/utils/area/cn.json'
import gd from '@/utils/area/guangdong.json'
import jsonp from '@/utils/jsonp'
import uuidv1 from 'uuid/v1'

let addressPicker = null // 地址控件
let asyncSelectedIndex = [0, 0, 0]
let level = 3 // 默认级联层级
let defaultVal = [] // 默认选中的地址
const addressData = JSON.parse(JSON.stringify(cn))
const Guangdong = JSON.parse(JSON.stringify(gd))

function getArea (area, i, cb) {
  if (i === (level - 1)) return
  if (!area || isNaN(area.areaCode)) return
  jsonp(`${appConfig.api.area}/${area.areaCode}`, {
    prefix: `__jc_area_${uuidv1().replace(/\-/g, '_')}`
  }, children => {
    if (area) {
      area.children = children.slice()
      if (area.areaLevel === 2 && defaultVal) {
        let index = area.children.findIndex(item => item.areaCode === defaultVal[2])
        asyncSelectedIndex[2] = index !== -1 ? index : 0
      }
      if (i < (level - 2)) { // 三级级联选中默认
        if (defaultVal.length > 0) {
          let index = area.children.findIndex(item => item.areaCode === defaultVal[1])
          asyncSelectedIndex[1] = index !== -1 ? index : 0
          cb(area.children[asyncSelectedIndex[1]], i + 1, getArea)
        } else {
          cb(area.children[asyncSelectedIndex[1]], i + 1, getArea)
        }
      }
      if (level === 2) { // 只有二级直接设置数据
        if (defaultVal.length > 0) { // 只有二级
          let index = area.children.findIndex(item => item.areaCode === defaultVal[1])
          asyncSelectedIndex[1] = index !== -1 ? index : 0
        }
        addressPicker.setData(addressData, asyncSelectedIndex)
      } // 等于二可以直接拿子数据
      if (i === (level - 2)) {
        addressPicker.setData(addressData, asyncSelectedIndex)
      }
    }
  })
}
function getGuangdongArea (area, i, cb) {
  if (i === (level - 1)) return
  if (!area || isNaN(area.areaCode)) return
  jsonp(`${appConfig.api.area}/${area.areaCode}`, {
    prefix: `__jc_area_${uuidv1().replace(/\-/g, '_')}`
  }, children => {
    if (area) {
      area.children = children.slice()
      if (area.areaLevel === 2 && defaultVal) {
        let index = area.children.findIndex(item => item.areaCode === defaultVal[2])
        asyncSelectedIndex[2] = index !== -1 ? index : 0
      }
      if (i < (level - 2)) { // 三级级联选中默认
        if (defaultVal.length > 0) {
          let index = area.children.findIndex(item => item.areaCode === defaultVal[1])
          asyncSelectedIndex[1] = index !== -1 ? index : 0
          cb(area.children[asyncSelectedIndex[1]], i + 1, getGuangdongArea)
        } else {
          cb(area.children[asyncSelectedIndex[1]], i + 1, getGuangdongArea)
        }
      }
      if (level === 2) { // 只有二级直接设置数据
        if (defaultVal.length > 0) { // 只有二级
          let index = area.children.findIndex(item => item.areaCode === defaultVal[1])
          asyncSelectedIndex[1] = index !== -1 ? index : 0
        }
        addressPicker.setData(Guangdong, asyncSelectedIndex)
      } // 等于二可以直接拿子数据
      if (i === (level - 2)) {
        addressPicker.setData(Guangdong, asyncSelectedIndex)
      }
    }
  })
}
export default {
  methods: {
    /**
     * @description 截取大于len位数的字符串并且拼接...
     * @param value {String} 待截取字符串
     * @param len {Number} 截取长度 默认20
     */
    sliceString (value, len = 20) {
      // 截取字符串
      if (!value || (value.trim && value.trim() === '') || !value.trim) return ''
      let val = value.trim()
      if (val.length <= len) return val
      else return val.substring(0, len) + '...'
    },
    /**
     * @description 分割数组，获取指定索引的元素
     * @param {Array} val 原数组
     * @param {String} separator 分隔符
     * @param {Number} index 索引
     */
    split (val, separator, index = 0) {
      if (!val || !val.split) return
      let vals = val.split(separator)
      if (vals.length > index) return vals[index]
      else return ''
    },
    /**
     * @description 获取广告位
     * @author yangyu
     */
    getBanners (name, pos) {
      return this.$api('common/getBanners', {}, {}, {
        append: pos
      })().then(res => {
        if (res) {
          // 轮播切换效果
          if (res.action) this[`${name}Options`].effect = appConfig.swiper[res.action.actionCode]
          if (res.image && res.image.length <= 1) {
            this[`${name}Options`].loop = false
            this[`${name}Options`].autoplay = false
          }
          this.$nextTick(() => { this[name] = res.image })
        }
      }).catch(err => {
        this.createToast(err).show()
      })
    },
    createToast (params, opts = {}) {
      let defaultOpts = {
        type: 'text',
        mask: false,
        time: 1000,
        maskClosable: true,
        zIndex: 1100
      }
      opts = Object.assign({}, defaultOpts, opts)
      let toast = this.$createToast({
        time: opts.time,
        txt: typeof params === 'object' ? (params.data && params.data.msg) || params.msg : params,
        type: opts.type,
        zIndex: opts.zIndex ? Popup.nextZIndex() : 900,
        mask: opts.mask,
        maskClosable: opts.maskClosable
      })
      return toast
    },
    createLoadingToast (txt = '加载中', mask = true, time = 0) {
      return this.$createToast({
        txt,
        mask,
        type: 'loading',
        time
      })
    },
    createDatePicker (title = '', value = new Date(), onSelect, opts = {}) {
      let defaultOpts = {
        mask: true,
        min: new Date(2008, 7, 8),
        max: new Date(2020, 9, 20),
        maskClosable: true,
        zIndex: true,
        subtitle: '',
        cancelTxt: '取消',
        confirmText: '确认',
        swipeTime: 2500,
        format: {
          year: 'YYYY',
          month: 'MM',
          date: 'DD'
        }
      }
      opts = Object.assign({}, defaultOpts, opts)
      return this.$createDatePicker({
        title,
        value,
        onSelect,
        ...opts,
        zIndex: opts.zIndex ? Popup.nextZIndex() : 900
      })
    },
    /**
     * 初始化级联选择器
     * @param title // 级联选择器的标题
     * @param value // 默认回显的值
     * @param opts // 其他操作例如别名或者回调方法
     * @returns {*} // 级联选择器的实例
     */
    initAddressPicker (title, value = [], opts) {
      asyncSelectedIndex = [0, 0, 0] // 出事话恢复默认索引
      addressPicker = this.createAddressPicker(title, value, opts)
      defaultVal = value
      if (Array.isArray(defaultVal) && defaultVal.length > 0) {
        let index = addressData.findIndex(item => item.areaCode === defaultVal[0])
        asyncSelectedIndex[0] = index
        getArea(addressData[index], 0, getArea) // 设置初始值
      } else {
        getArea(addressData[0], 0, getArea) // 设置初始值
      }
      return addressPicker
    },
    initGuangdongAddressPicker (title, value = [], opts) {
      asyncSelectedIndex = [0, 0, 0] // 出事话恢复默认索引
      addressPicker = this.createGuangdongAddressPicker(title, value, opts)
      defaultVal = value
      if (Array.isArray(defaultVal) && defaultVal.length > 0) {
        let index = Guangdong.findIndex(item => item.areaCode === defaultVal[0])
        asyncSelectedIndex[0] = index
        getGuangdongArea(Guangdong[index], 0, getGuangdongArea) // 设置初始值
      } else {
        getGuangdongArea(Guangdong[0], 0, getGuangdongArea) // 设置初始值
      }
      return addressPicker
    },
    /**
     * @author lixian
     * @param i // 级联选择器自动带的参数，改变的级别
     * @param newIndex // 改变的索引位置
     */
    asyncChangeHandle (i, newIndex) { // 当前选中级别，选中项的索引
      if (newIndex !== asyncSelectedIndex[i]) {
        asyncSelectedIndex[i] = newIndex
        if (i < 2) {
          if (i === 0) { // 一级选项触发
            const current = addressData[newIndex]
            if (current.children) { // 没有数据再去加载
              getArea(current, i, getArea)
            }
            // current.children[0].children = this.getChildren(current.children[0][this.prop.id]) // 获取下级对象
            asyncSelectedIndex[1] = 0
            asyncSelectedIndex[2] = 0
          }
          if (i === 1) {
            const current = addressData[asyncSelectedIndex[0]].children[newIndex]
            asyncSelectedIndex[2] = 0
            if (!current.children) { // 没有数据再去加载
              getArea(current, i, getArea)
            } else {
              addressPicker.setData(addressData, asyncSelectedIndex)
            }
          }
        }
      }
    },
    asyncGuangdongChangeHandle (i, newIndex) { // 当前选中级别，选中项的索引
      if (newIndex !== asyncSelectedIndex[i]) {
        asyncSelectedIndex[i] = newIndex
        if (i < 2) {
          if (i === 0) { // 一级选项触发
            const current = Guangdong[newIndex]
            if (current.children) { // 没有数据再去加载
              getGuangdongArea(current, i, getGuangdongArea)
            }
            // current.children[0].children = this.getChildren(current.children[0][this.prop.id]) // 获取下级对象
            asyncSelectedIndex[1] = 0
            asyncSelectedIndex[2] = 0
          }
          if (i === 1) {
            const current = Guangdong[asyncSelectedIndex[0]].children[newIndex]
            asyncSelectedIndex[2] = 0
            if (!current.children) { // 没有数据再去加载
              getGuangdongArea(current, i, getGuangdongArea)
            } else {
              addressPicker.setData(Guangdong, asyncSelectedIndex)
            }
          }
        }
      }
    },
    /**
     * @author lixian
     * @description 创建一个级联选择器
     */
    createAddressPicker (title, value, opts = {level: 3}) {
      level = opts.level
      return this.$createCascadePicker({ // 创建城市级联控件
        title: title, // 标题名称
        async: opts.async ? opts.async : false, // 异步加载
        data: addressData, // 地址数据
        zIndex: opts.zIndex ? Popup.nextZIndex() : 900,
        onSelect: opts.selectHandle, // 选中确定事件
        onCancel: opts.cancelHandle, // 取消选择
        alias: opts.alias, // 设置选项别名
        onChange: this.asyncChangeHandle // 选项改变事件
      })
    },
    createGuangdongAddressPicker (title, value, opts = {level: 3}) {
      level = opts.level
      return this.$createCascadePicker({ // 创建城市级联控件
        title: title, // 标题名称
        async: opts.async ? opts.async : false, // 异步加载
        data: Guangdong, // 地址数据
        zIndex: opts.zIndex ? Popup.nextZIndex() : 900,
        onSelect: opts.selectHandle, // 选中确定事件
        onCancel: opts.cancelHandle, // 取消选择
        alias: opts.alias, // 设置选项别名
        onChange: this.asyncGuangdongChangeHandle // 选项改变事件
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/mixins/index.js